import { isNumberLike } from "./is-number-like";
import type { MetricRangeInput } from "./validate-metric-ranges";

export const isInIdealMetricRange = ({
  value,
  metricRanges,
}: {
  value: number;
  metricRanges: MetricRangeInput[];
}) => {
  const idealRange = metricRanges.find((mr) => mr.ideal);

  if (!idealRange) throw new Error("No ideal range found");

  const { rangeMin, rangeMax } = idealRange;

  const isAboveMin = !isNumberLike(rangeMin) || Number(rangeMin) <= value;
  const isBelowMax = !isNumberLike(rangeMax) || Number(rangeMax) >= value;

  return isAboveMin && isBelowMax;
};
